import { Dispatch, SetStateAction } from "react";

export type PlaygroundFilter = "all" | "playground" | "non-playground";
export type ExpandedFilter = "search" | "dropdown" | "date" | null;
export type DateRangeType = { from?: Date; to?: Date } | null;

export type AgentConversationListFilterProps = {
  activeTab: "public" | "private";
  queryParams: {
    start_date: string;
    end_date: string;
    user_id: string;
    user_email: string;
    filter_type: string;
    query: string;
  };
  setQueryParams: Dispatch<SetStateAction<any>>;
  playgroundFilter: PlaygroundFilter;
  onPlaygroundFilterChange: (value: PlaygroundFilter) => void;
};

export const USER_PAGE_SIZE = 10;
